import React from 'react';
import './SimpleImageList.css';

const SimpleImageList = ({ images, projectTitle }) => {
    const isVideo = (src) => {
        return src.toLowerCase().endsWith('.webm') || 
               src.toLowerCase().endsWith('.mp4') || 
               src.toLowerCase().endsWith('.mov') ||
               src.toLowerCase().endsWith('.ogg');
    };

    return (
        <div className="simple-image-list">
            {images.map((src, index) => (
                <div key={index} className="image-item">
                    {isVideo(src) ? (
                        <video
                            src={src}
                            autoPlay
                            muted
                            loop
                            playsInline
                            style={{ width: '100%', height: 'auto', display: 'block' }}
                        >
                            Your browser does not support the video tag.
                        </video>
                    ) : (
                        <img 
                            src={src} 
                            alt={`${projectTitle} ${index + 1}`}
                            loading="lazy"
                        />
                    )}
                </div>
            ))}
        </div>
    );
};

export default SimpleImageList;
